module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete","warning":"Delete this customer (here, and from the server)"},"es":{"title":"Borrar","warning":"Eliminar este cliente (aquí y del servidor)"},"sw":{"title":"Futa","warning":"Futa mteja huyu (hapa, na kutoka kwa seva)"}}')
  delete Component.options._Ctor
}
